import $ from "jquery";
import { Luminous, LuminousGallery } from "luminous-lightbox";
import { validateEmail } from "../../helpers/utils";

$(".add-to-cart-btn").on("click", function (showModal) {
    if ($(this).parents(".price-chooser")) {
        $(this).parents("label").siblings("input").prop("checked", true);
    }

    if ($(this).parents("label").hasClass("s-option") && showModal) {
        luxPopup.popupShow("lux-modal-normal-price");
        return;
    }

    if ($(this).parents("label").hasClass("g-option") && showModal) {
        luxPopup.popupShow("lux-modal-guest-price");
        return;
    }

    addToCart(showModal);
});

function addToCart(showModal) {
    if (showModal === undefined) {
        showModal = true;
    }

    //NGK: Used for tracking
    if (window.location.hash) {
        const hash = window.location.hash.substring(1);
        let productPrice = window.PRODUCTPRICE;
        //Just a simple error prevention.
        if (productPrice === "") productPrice = "0";
        productPrice = parseFloat(productPrice);
        window._gaq = window._gaq || [];
        switch (hash) {
            case "trck_rs": //similarity
                _gaq.push([
                    "_trackEvent",
                    "Recommendation Tracking",
                    "addedToCart",
                    "Recommendation Similarity",
                    parseFloat(productPrice),
                ]);
                break;
            case "trck_rsl": //shelf life
                _gaq.push([
                    "_trackEvent",
                    "Recommendation Tracking",
                    "addedToCart",
                    "Recommendation Shelf Life",
                    parseFloat(productPrice),
                ]);
                break;
            case "trck_obw": //often bought with
                _gaq.push([
                    "_trackEvent",
                    "Recommendation Tracking",
                    "addedToCart",
                    "Recommendation Often Bought With",
                    parseFloat(productPrice),
                ]);
                break;
            default:
        }
    }

    let membersprice = 0;
    if (
        $("input:radio[name ='price-selector']:checked").val() ===
        "membersprice"
    ) {
        membersprice = 1;
        $(".product-text-membership").show();
    }

    $(".add-to-cart-btn").html('<i class="fa fa-spin fa-spinner"></i>');

    const hideUpsell = "hide-upsell";

    basket.addProduct(
        window.PRODUCTSLUG,
        membersprice,
        () => {
            $(".add-to-cart-btn").html(
                '<img src="https://luxplus.imgix.net/content/icons/2025/check.svg" alt="" class="svg-filter-white" style="width: 1rem">',
            );
            setTimeout(() => {
                $(".add-to-cart-btn").html(window.TEXT95);
            }, 4000);
        },
        hideUpsell,
    );

    $("html, body").animate(
        {
            scrollTop: $(".upsell-container").offset().top,
        },
        500,
    );
    setTimeout(() => {
        $(".upsell-container").slideDown();
    }, 250);
}

function closeUpsell() {
    $(".close-upsell").on("click", () => {
        $(".upsell-container").slideUp();
    });
}

const options = {
    onOpen() {
        $("#bodyholder").addClass("lightbox-open");
    },
    onClose() {
        $("#bodyholder").removeClass("lightbox-open");
    },
};

$(() => {
    $("body").on(
        "click",
        '#lux-modal-normal-price button:not(".lux-popup-close"), #lux-modal-guest-price button:not(".lux-popup-close")',
        function (e) {
            if ($(this).data("option") === "f-option") {
                $("#f-option").click();
                addToCart(true);
            } else if ($(this).data("option") === "close") {
                return;
            } else {
                addToCart(false);
            }
        },
    );

    $("select.variants").on("change", function (e) {
        window.location = $(this).val();
    });

    $(".gallery-product-picture-trigger").on("click", function () {
        $(this)
            .parents(".product-image")
            .siblings(".product-gallery-wrapper")
            .find("#gallery-product-picture img")
            .trigger("click");
    });

    let singlePicture = document.querySelectorAll(".single-picture");

    if (singlePicture !== null) {
        singlePicture.forEach(function (picture) {
            new Luminous(picture, options);
        });
    }

    let productGalleryItems = document.querySelectorAll(".product-gallery");
    if (productGalleryItems !== null) {
        new LuminousGallery(
            productGalleryItems,
            { arrowNavigation: true },
            options,
        );
    }

    $(".thumbImage").click(function () {
        $("#productImage").attr("src", $(this).attr("src")).show();
        $("#product360Image").attr("style", "display:none !important").hide();
    });

    $(".thumb360Image").click(() => {
        $("#product360Image").show();
        $("#productImage").hide();
    });

    $(".upsell-container").css({
        height: "auto",
        overflow: "initial",
        display: "none",
    });

    closeUpsell();
});

$(() => {
    const expandText = function () {
        if (origText.length > 240) {
            $(this).html(`${origHtml.slice(0, 280)}...`);

            $(".toggle-description-wrapper a").on("click", function () {
                $(this)
                    .parents(".toggle-description-wrapper")
                    .siblings(".product-description-wrapper")
                    .removeClass("ellipsis");
                $(this)
                    .parents(".toggle-description-wrapper")
                    .siblings(".product-description-wrapper")
                    .html(origHtml);
            });
        }
    };

    var origText = null;
    var origHtml = null;
    if ($(window).width() < 765) {
        origText = $(
            ".product-right-wrapper .product-description-wrapper.ellipsis",
        ).text();
        origHtml = $(
            ".product-right-wrapper .product-description-wrapper.ellipsis",
        ).html();
    } else {
        origText = $(
            ".product-main-wrapper .product-description-wrapper.ellipsis",
        ).text();
        origHtml = $(
            ".product-main-wrapper .product-description-wrapper.ellipsis",
        ).html();
    }
    expandText();
});

$(".price-chooser .lux-radio").on("click", function () {
    $(this).addClass("active");
    $(this).siblings(".lux-radio").removeClass("active");
    $(this).parents(".not-active").removeClass("not-active");
});
